<h2 mat-dialog-title> Nuevo residuo</h2>
<mat-dialog-content>

  <form [formGroup]="form">
    <mat-form-field class='formField'>
      <mat-label>Nombre</mat-label>
      <input matInput placeholder="Nombre" formControlName="nombre">
    </mat-form-field>
    <mat-form-field class='formField'>
      <mat-label>Descripción</mat-label>
      <input matInput placeholder="Descripción" formControlName="descripcion">
    </mat-form-field>
    <mat-form-field class='formField'>
      <mat-label>Tipo</mat-label>
      <mat-select formControlName="tipo">
        <mat-option value="Pesaje">Pesaje</mat-option>
        <mat-option value="Clasificación">Clasificación</mat-option>
      </mat-select>
      <mat-error>El tipo es obligatorio</mat-error>
    </mat-form-field>
    <mat-slide-toggle class='sliderCheck' [checked]="activo" color='primary' formControlName="activo">Activo</mat-slide-toggle>
  </form>


</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button (click)="close()">Cancelar</button>
  <button mat-button (click)="save()">Guardar</button>
</mat-dialog-actions>
